/* /assets/lab.js – behaviour for the Acrobatics Lab landing page (sections/lab-*.liquid).
   Loaded by every lab section; the guard makes sure it only runs once. */
(function () {
  if (window.LabPage) return;
  window.LabPage = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Anchor links: #next, #id or #section_key (matches the Shopify section wrapper id) ---------- */
  function resolveTarget(href, from) {
    if (href === '#next') {
      var section = from.closest('.shopify-section');
      var el = section && section.nextElementSibling;
      while (el && (el.offsetHeight === 0 || getComputedStyle(el).display === 'none')) el = el.nextElementSibling;
      return el;
    }
    var id = href.slice(1);
    if (!id) return null;
    return document.getElementById(id) || document.querySelector('[id$="__' + id.replace(/"/g, '') + '"]');
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-lab-link]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var target = resolveTarget(href, link);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Trailer dialog ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lab-trailer]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-lab-trailer'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var iframe = dialog.querySelector('iframe[data-src]');
      if (iframe) iframe.src = iframe.getAttribute('data-src');
      dialog.showModal();
      var video = dialog.querySelector('video');
      if (video) video.play().catch(function () {});
      return;
    }
    var closer = e.target.closest('[data-lab-dialog-close]');
    if (closer) {
      closer.closest('dialog').close();
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('lab-dialog')) e.target.close();
  });

  document.addEventListener('close', function (e) {
    var dialog = e.target;
    if (!dialog.classList || !dialog.classList.contains('lab-dialog')) return;
    var iframe = dialog.querySelector('iframe[data-src]');
    if (iframe) iframe.removeAttribute('src');
    var video = dialog.querySelector('video');
    if (video) video.pause();
  }, true);

  /* ---------- Muted loops play only while visible ---------- */
  function initVideos(root) {
    var videos = root.querySelectorAll('video[data-lab-autoplay]:not([data-lab-bound])');
    if (!videos.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    /* fixed (parallax) backgrounds always intersect the viewport, so they watch their section instead */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        (entry.target.__labVideos || []).forEach(function (v) {
          if (entry.isIntersecting && !v.closest('[hidden]')) {
            v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      });
    }, { rootMargin: '120px 0px' });
    videos.forEach(function (v) {
      v.setAttribute('data-lab-bound', '');
      v.muted = true;
      var target = v.closest('[data-lab-video-root]') || v;
      (target.__labVideos = target.__labVideos || []).push(v);
      io.observe(target);
    });
  }

  /* ---------- Trailer stage: muted preview loop, the play buttons start the full trailer in place ---------- */
  function playStage(stage) {
    var player = stage.querySelector('[data-lab-stage-player]');
    if (!player) return;
    var preview = stage.querySelector('[data-lab-stage-preview]');
    if (preview) {
      preview.hidden = true;
      preview.querySelectorAll('video').forEach(function (v) { v.pause(); });
    }
    player.hidden = false;
    stage.classList.add('is-playing');
    var iframe = player.querySelector('iframe[data-src]');
    if (iframe && !iframe.getAttribute('src')) iframe.src = iframe.getAttribute('data-src');
    var video = player.querySelector('video');
    if (video) video.play().catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lab-play-trailer]');
    if (!btn) return;
    var stage = document.getElementById(btn.getAttribute('data-lab-play-trailer'));
    if (!stage) return;
    e.preventDefault();
    playStage(stage);
    var rect = stage.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      stage.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  });

  /* ---------- Count up numbers like "20+" ---------- */
  function initCounts(root) {
    var els = root.querySelectorAll('[data-lab-count]:not([data-lab-bound])');
    if (!els.length || reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var raw = el.getAttribute('data-lab-count');
        var match = raw.match(/^(\D*)(\d+)(.*)$/);
        if (!match) return;
        var target = parseInt(match[2], 10);
        var start = null;
        var duration = 1200;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = match[1] + Math.round(target * eased) + match[3];
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) {
      el.setAttribute('data-lab-bound', '');
      io.observe(el);
    });
  }

  /* ---------- Launch price + countdown ---------- */
  function parseEnd(str) {
    if (!str) return null;
    str = str.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) str += 'T23:59:59+01:00';
    var d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  }

  function endLaunch() {
    document.documentElement.classList.add('lab-launch-ended');
    document.querySelectorAll('[data-lab-launch]').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('[data-lab-regular]').forEach(function (el) { el.hidden = false; });
    document.querySelectorAll('[data-lab-href-regular]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('data-lab-href-regular'));
    });
    document.querySelectorAll('[data-lab-cart-return]').forEach(function (input) { input.value = '/cart'; });
  }

  /* the launch code can live in any lab section (hero or offer); every checkout link and cart form uses it */
  function applyDiscount(code) {
    if (!code) return;
    var enc = encodeURIComponent(code);
    document.querySelectorAll('[data-lab-href-regular]').forEach(function (a) {
      if ((a.getAttribute('href') || '').indexOf('discount=') !== -1) return;
      a.setAttribute('href', a.getAttribute('data-lab-href-regular') + '?discount=' + enc);
    });
    document.querySelectorAll('[data-lab-cart-return]').forEach(function (input) {
      input.value = '/discount/' + enc + '?redirect=/cart';
    });
  }

  var launchTimer = null;
  function initLaunch() {
    var holders = document.querySelectorAll('[data-lab-launch-end]');
    if (!holders.length) return;
    var off = false;
    var end = null;
    var code = '';
    holders.forEach(function (h) {
      var value = h.getAttribute('data-lab-launch-end');
      if (value === 'off') off = true;
      if (!end) end = parseEnd(value);
      if (!code) code = (h.getAttribute('data-lab-discount') || '').trim();
    });
    if (off) {
      endLaunch();
      return;
    }
    if (end && end.getTime() <= Date.now()) {
      endLaunch();
      return;
    }
    applyDiscount(code);
    if (!end) return;
    if (launchTimer) clearInterval(launchTimer);

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        endLaunch();
        return false;
      }
      var s = Math.floor(diff / 1000);
      var parts = {
        d: Math.floor(s / 86400),
        h: Math.floor((s % 86400) / 3600),
        m: Math.floor((s % 3600) / 60),
        s: s % 60
      };
      document.querySelectorAll('[data-lab-countdown]').forEach(function (timer) {
        Object.keys(parts).forEach(function (k) {
          var el = timer.querySelector('[data-unit="' + k + '"]');
          if (el) el.textContent = pad(parts[k]);
        });
      });
      return true;
    }
    if (tick()) {
      launchTimer = setInterval(function () {
        if (!tick()) clearInterval(launchTimer);
      }, 1000);
    }
  }

  /* ---------- Sticky mobile CTA: visible after the hero, hidden while the offer is on screen ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-lab-sticky]:not([data-lab-bound])');
    if (!bar || !('IntersectionObserver' in window)) return;
    bar.setAttribute('data-lab-bound', '');
    var hero = bar.closest('.lab');
    var offers = document.querySelectorAll('[data-lab-offer]');
    var pastHero = false;
    var visibleOffers = new Set();

    function update() {
      var show = pastHero && visibleOffers.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    }

    new IntersectionObserver(function (entries) {
      pastHero = !entries[0].isIntersecting;
      update();
    }).observe(hero);

    var offerIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visibleOffers.add(entry.target);
        else visibleOffers.delete(entry.target);
      });
      update();
    });
    offers.forEach(function (o) { offerIo.observe(o); });
    update();
  }

  function init(root) {
    initVideos(root);
    initCounts(root);
    initLaunch();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
